import { SectorCheck } from '@/types';

export const supportedSectors: SectorCheck[] = [
  {
    id: 'drone_service_provider',
    value: 'Drone Service Provider',
    checked: false,
  },
  {
    id: 'mining_quarries_aggregates',
    value: 'Mining, Quarries & Aggregates',
    checked: false,
  },
  {
    id: 'engineering_construction',
    value: 'Engineering & Construction',
    checked: false,
  },
  {
    id: 'energy_utilities',
    value: 'Energy & Utilities',
    checked: false,
  },
  {
    id: 'mapping_gis',
    value: 'Mapping & GIS',
    checked: false,
  },
  {
    id: 'environmental',
    value: 'Environmental',
    checked: false,
  },
  {
    id: 'agriculture',
    value: 'Agriculture',
    checked: false,
  },
  {
    id: 'education',
    value: 'Education',
    checked: false,
  },
  {
    id: 'government',
    value: 'Government',
    checked: false,
  },
  {
    id: 'surveillance',
    value: 'Surveillance',
    checked: false,
  },
  {
    id: 'others',
    value: 'Others',
    checked: false,
  },
];




// WEBPACK FOOTER //
// ./src/static/supportedSectors.ts